<div class="sidebar-outer">
    <a class="logo d-flex align-items-center" routerLink="/" (click)="closeSubMenus()"
        *ngIf="settings.theme.sidebarIsFixed">
        <img src="assets/img/app/header_icon.png">
        <span *ngIf="settings.theme.menuType != 'mini' || settings.theme.menu == 'horizontal'" class="ng pl-2">iDrv</span>
    </a>
    <app-vertical-menu [menuItems]="menuItems"></app-vertical-menu>
</div>